module.exports = __webpack_public_path__ + "static/img/cashWheelPop.b06e01b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/cashWheelPop.webp
// module id = BaR1
// module chunks = 0